export const getSelectedCurrency = () => localStorage.getItem('currency') || 'EUR';

export const getCurrencySymbol = (currency) => {
  const map = {
    EUR: '€',
    GBP: '£',
  };
  return map[currency] || currency;
};

export const getEurToGbpRate = () => {
  const raw = localStorage.getItem('rate_gbp');
  const rate = raw ? parseFloat(raw) : NaN;
  return Number.isFinite(rate) ? rate : null;
};

export const convertFromEur = (amount, currency, rate = null) => {
  const value = Number(amount) || 0;
  if (currency !== 'GBP') return value;
  const activeRate = rate ?? getEurToGbpRate();
  if (!activeRate) return value;
  return value * activeRate;
};

export const formatMoney = (amount, currency) => {
  const value = Number(amount) || 0;
  const symbol = getCurrencySymbol(currency);
  return `${symbol}${value.toFixed(2)}`;
};

export const formatFromEur = (amount, currency, rate = null) =>
  formatMoney(convertFromEur(amount, currency, rate), currency);
